var map = {
	"./foods/Beans_Nuts_Legumes/12006_chia_seeds.jpg": 8871,
	"./foods/Beans_Nuts_Legumes/12012_hemp_seeds.jpg": 28939,
	"./foods/Beans_Nuts_Legumes/12016_pumpkin_seeds_unsalted.jpg": 97606,
	"./foods/Beans_Nuts_Legumes/12029_sesame_seeds_unsalted.jpg": 78448,
	"./foods/Beans_Nuts_Legumes/12061_almonds_unsalted.jpg": 19901,
	"./foods/Beans_Nuts_Legumes/12078_brazil_nuts_unsalted.jpg": 45516,
	"./foods/Beans_Nuts_Legumes/12085_cashews_unsalted.jpg": 20747,
	"./foods/Beans_Nuts_Legumes/12104_coconut_raw.jpg": 23662,
	"./foods/Beans_Nuts_Legumes/12119_coconut_water.jpg": 75339,
	"./foods/Beans_Nuts_Legumes/12120_hazelnuts_filberts.jpg": 83950,
	"./foods/Beans_Nuts_Legumes/12132_macademia_nuts_unsalted.jpg": 43161,
	"./foods/Beans_Nuts_Legumes/12142_pecans_unsalted.jpg": 98847,
	"./foods/Beans_Nuts_Legumes/12147_pine_nuts_unsalted.jpg": 5009,
	"./foods/Beans_Nuts_Legumes/12152_pistachio_nuts_salted.jpg": 97472,
	"./foods/Beans_Nuts_Legumes/12155_walnuts_unsalted.jpg": 55569,
	"./foods/Beans_Nuts_Legumes/12179_coconut_sweetened.jpg": 93502,
	"./foods/Beans_Nuts_Legumes/12195_almond_butter_unsalted.jpg": 52471,
	"./foods/Beans_Nuts_Legumes/12220_flaxseed.jpg": 99075,
	"./foods/Beans_Nuts_Legumes/12516_pumpkin_seeds_salted.jpg": 56504,
	"./foods/Beans_Nuts_Legumes/12529_sesame_seeds_salted.jpg": 95020,
	"./foods/Beans_Nuts_Legumes/12563_almonds_salted.jpg": 47641,
	"./foods/Beans_Nuts_Legumes/12585_cashews_salted.jpg": 83377,
	"./foods/Beans_Nuts_Legumes/12632_macademia_nuts_salted.jpg": 56015,
	"./foods/Beans_Nuts_Legumes/12652_pistachio_nuts_unsalted.jpg": 15014,
	"./foods/Beans_Nuts_Legumes/12663_pumpkin_seeds_whole_salted.jpg": 26225,
	"./foods/Beans_Nuts_Legumes/16002_adzuki_beans.jpg": 6647,
	"./foods/Beans_Nuts_Legumes/16005_baked_beans.jpg": 83917,
	"./foods/Beans_Nuts_Legumes/16028_kidney_beans.jpg": 7207,
	"./foods/Beans_Nuts_Legumes/16038_navy_beans.jpg": 95542,
	"./foods/Beans_Nuts_Legumes/16043_pinto_beans.jpg": 1476,
	"./foods/Beans_Nuts_Legumes/16053_broad_beans.jpg": 93797,
	"./foods/Beans_Nuts_Legumes/16057_chickpeas.jpg": 84116,
	"./foods/Beans_Nuts_Legumes/16070_lentils.jpg": 30403,
	"./foods/Beans_Nuts_Legumes/16072_lima_beans.jpg": 44875,
	"./foods/Beans_Nuts_Legumes/16086_split_peas.jpg": 62593,
	"./foods/Beans_Nuts_Legumes/16089_peanuts_salted.jpg": 15996,
	"./foods/Beans_Nuts_Legumes/16114_tempeh.jpg": 60654,
	"./foods/Beans_Nuts_Legumes/16124_soy_sauce.jpg": 50589,
	"./foods/Beans_Nuts_Legumes/16157_chickpea_flour.jpg": 77753,
	"./foods/Beans_Nuts_Legumes/16389_peanuts_unsalted.jpg": 72868,
	"./foods/Beans_Nuts_Legumes/16398_peanut_butter_natural_unsalted.jpg": 30750,
	"./foods/Beans_Nuts_Legumes/16427_tofu.jpg": 49190,
	"./foods/Beans_Nuts_Legumes/43212_meatless_bacon_bits.jpg": 74473,
	"./foods/Dairy/01004_blue_cheese.jpg": 22367,
	"./foods/Dairy/01006_brie_cheese.jpg": 64127,
	"./foods/Dairy/01007_camembert_cheese.jpg": 94468,
	"./foods/Dairy/01009_cheddar_cheese.jpg": 5025,
	"./foods/Dairy/01012_cottage_cheese.jpg": 59045,
	"./foods/Dairy/01017_cream_cheese.jpg": 61213,
	"./foods/Dairy/01019_feta_cheese.jpg": 78995,
	"./foods/Dairy/01022_gouda_cheese.jpg": 84225,
	"./foods/Dairy/01023_gruyere_cheese.jpg": 62663,
	"./foods/Dairy/01026_mozzarella_cheese.jpg": 9958,
	"./foods/Dairy/01033_parmesan_cheese.jpg": 92068,
	"./foods/Dairy/01035_provolone_cheese.jpg": 62435,
	"./foods/Dairy/01036_roicotta_cheese.jpg": 74847,
	"./foods/Dairy/01040_swiss_cheese.jpg": 47120,
	"./foods/Dairy/01049_cream_half.jpg": 13082,
	"./foods/Dairy/01052_whipping_cream.jpg": 87513,
	"./foods/Dairy/01056_sour_cream.jpg": 41256,
	"./foods/Dairy/01077_whole_milk.jpg": 13436,
	"./foods/Dairy/01082_milk_one_percent.jpg": 81503,
	"./foods/Dairy/01116_yogurt_plain_whole_milk.jpg": 20740,
	"./foods/Dairy/01117_yogurt_plain_low_fat.jpg": 46888,
	"./foods/Dairy/01159_goat_cheese.jpg": 89771,
	"./foods/Dairy/01236_ice_cream.jpg": 64000,
	"./foods/Fats_Oils/04002_lard.jpg": 58900,
	"./foods/Fats_Oils/04600_margarine.jpg": 99911,
	"./foods/Fats_Oils/04601_butter_salted.jpg": 31412,
	"./foods/Fats_Oils/04602_butter_unsalted.jpg": 31870,
	"./foods/Fats_Oils/04615_vegetable_shortening.jpg": 7048,
	"./foods/Fats_Oils/43598_mayonnaise.jpg": 10036,
	"./foods/Fats_Oils/notlisted_cooking_oils.jpg": 45025,
	"./foods/Fruits/09004_apples.jpg": 17824,
	"./foods/Fruits/09011_apples_dried.jpg": 86923,
	"./foods/Fruits/09021_apricots.jpg": 6127,
	"./foods/Fruits/09032_apricots_dried.jpg": 5870,
	"./foods/Fruits/09037_avocados.jpg": 77687,
	"./foods/Fruits/09040_bananas.jpg": 96373,
	"./foods/Fruits/09041_dehydrated_bananas.jpg": 20433,
	"./foods/Fruits/09042_blackberries.jpg": 53466,
	"./foods/Fruits/09050_blueberries.jpg": 36156,
	"./foods/Fruits/09060_starfruit.jpg": 84171,
	"./foods/Fruits/09063_sour_cherries.jpg": 27099,
	"./foods/Fruits/09070_sweet_cherries.jpg": 85580,
	"./foods/Fruits/09077_crabapples.jpg": 22692,
	"./foods/Fruits/09078_cranberries.jpg": 63600,
	"./foods/Fruits/09079_dried_cranberries.jpg": 62044,
	"./foods/Fruits/09088_elderberries.jpg": 95955,
	"./foods/Fruits/09089_figs.jpg": 48057,
	"./foods/Fruits/09094_figs_dried.jpg": 37330,
	"./foods/Fruits/09107_gooseberries.jpg": 27682,
	"./foods/Fruits/09111_grapefruit.jpg": 98791,
	"./foods/Fruits/09132_grapes.jpg": 59493,
	"./foods/Fruits/09139_guava.jpg": 64040,
	"./foods/Fruits/09144_jackfruit.jpg": 89767,
	"./foods/Fruits/09148_kiwi.jpg": 52572,
	"./foods/Fruits/09150_lemons.jpg": 1361,
	"./foods/Fruits/09159_limes.jpg": 18310,
	"./foods/Fruits/09163_blueberries_dried.jpg": 49322,
	"./foods/Fruits/09164_litchis.jpg": 54594,
	"./foods/Fruits/09176_mangos.jpg": 66788,
	"./foods/Fruits/09181_cantaloupe.jpg": 7011,
	"./foods/Fruits/09184_honeydew_melon.jpg": 4607,
	"./foods/Fruits/09190_mulberries.jpg": 95543,
	"./foods/Fruits/09191_nectarines.jpg": 40764,
	"./foods/Fruits/09195_olives.jpg": 11306,
	"./foods/Fruits/09200_oranges.jpg": 8524,
	"./foods/Fruits/09218_tangerines_mandarin.jpg": 11433,
	"./foods/Fruits/09226_papayas.jpg": 24380,
	"./foods/Fruits/09231_passion_fruit.jpg": 18037,
	"./foods/Fruits/09236_peaches.jpg": 55309,
	"./foods/Fruits/09246_peaches_dried.jpg": 93545,
	"./foods/Fruits/09252_pears.jpg": 28695,
	"./foods/Fruits/09259_pears_dried.jpg": 78977,
	"./foods/Fruits/09263_persimmons.jpg": 15221,
	"./foods/Fruits/09266_pineapple.jpg": 29155,
	"./foods/Fruits/09279_plums.jpg": 5116,
	"./foods/Fruits/09286_pomegranates.jpg": 12759,
	"./foods/Fruits/09287_prickly_pears.jpg": 51828,
	"./foods/Fruits/09289_prunes_dehydrated.jpg": 75384,
	"./foods/Fruits/09291_plums_dried.jpg": 94343,
	"./foods/Fruits/09295_pummelo.jpg": 41892,
	"./foods/Fruits/09299_raisins.jpg": 5658,
	"./foods/Fruits/09302_raspberries.jpg": 79900,
	"./foods/Fruits/09307_rhubarb.jpg": 46471,
	"./foods/Fruits/09316_strawberries.jpg": 70674,
	"./foods/Fruits/09322_tamarinds.jpg": 18597,
	"./foods/Fruits/09326_watermelon.jpg": 74252,
	"./foods/Fruits/09340_asian_pears.jpg": 64854,
	"./foods/Fruits/09421_medjool_dates.jpg": 64424,
	"./foods/Fruits/09422_durian.jpg": 19376,
	"./foods/Fruits/09433_clementine.jpg": 98605,
	"./foods/Fruits/09451_horned_melon.jpg": 1057,
	"./foods/Fruits/09542_plantains.jpg": 20080,
	"./foods/Grains/18041_pita_bread.jpg": 30674,
	"./foods/Grains/18060_rye_bread.jpg": 76481,
	"./foods/Grains/18064_bread_whole_wheat.jpg": 72700,
	"./foods/Grains/18079_bread_crumbs.jpg": 30023,
	"./foods/Grains/18248_doughnuts.jpg": 36975,
	"./foods/Grains/18342_dinner_rolls.jpg": 32700,
	"./foods/Grains/18350_hamburger_hot_dog_rolls.jpg": 37291,
	"./foods/Grains/18370_baking_powder.jpg": 82024,
	"./foods/Grains/18371_baking_powder_low_sodium.jpg": 95442,
	"./foods/Grains/18372_baking_soda.jpg": 5246,
	"./foods/Grains/18373_cream_of_tartar.jpg": 40394,
	"./foods/Grains/18375_baker's_yeast.jpg": 61177,
	"./foods/Grains/18407_bagel_plain.jpg": 48095,
	"./foods/Grains/18967_bread_white.jpg": 94620,
	"./foods/Grains/18968_bagel_whole_wheat.jpg": 49982,
	"./foods/Grains/18972_cheese_bread.jpg": 55020,
	"./foods/Grains/18973_focaccia.jpg": 86138,
	"./foods/Grains/20006_pearl_barley.jpg": 49709,
	"./foods/Grains/20008_buckwheat.jpg": 42061,
	"./foods/Grains/20013_bulgur.jpg": 9190,
	"./foods/Grains/20017_corn_flour.jpg": 22372,
	"./foods/Grains/20027_cornstarch.jpg": 29983,
	"./foods/Grains/20029_couscous.jpg": 37930,
	"./foods/Grains/20032_millet.jpg": 1687,
	"./foods/Grains/20034_oat_bran.jpg": 53026,
	"./foods/Grains/20037_brown_rice.jpg": 27625,
	"./foods/Grains/20038_oats.jpg": 60247,
	"./foods/Grains/20055_white_rice.jpg": 45768,
	"./foods/Grains/20080_wheat_flour.jpg": 56691,
	"./foods/Grains/20081_all_puprose_flour.jpg": 16709,
	"./foods/Grains/20089_wild_rice.jpg": 34170,
	"./foods/Grains/20090_brown_rice_flour.jpg": 45355,
	"./foods/Grains/20109_egg_noodles.jpg": 35905,
	"./foods/Grains/20115_soba_noodles.jpg": 90222,
	"./foods/Grains/20121_pasta_without_added_salt.jpg": 24351,
	"./foods/Grains/20130_barley_flour.jpg": 4145,
	"./foods/Grains/20134_rice_noodles.jpg": 34141,
	"./foods/Grains/20137_quinoa.jpg": 98133,
	"./foods/Grains/20322_cornmeal.jpg": 33081,
	"./foods/Grains/28306_chapati_roti.jpg": 66921,
	"./foods/Grains/28307_naan.jpg": 64481,
	"./foods/Grains/28315_cinnamon_bread.jpg": 58970,
	"./foods/Grains/28320_english_muffins.jpg": 51505,
	"./foods/Meat_Fish_Eggs/01124_egg_whites.jpg": 47520,
	"./foods/Meat_Fish_Eggs/01128_egg_whole.jpg": 52405,
	"./foods/Meat_Fish_Eggs/05026_chicken_hearts.jpg": 72942,
	"./foods/Meat_Fish_Eggs/05027_chicken_livers.jpg": 89609,
	"./foods/Meat_Fish_Eggs/05112_roasted_chicken.jpg": 69797,
	"./foods/Meat_Fish_Eggs/05140_duck.jpg": 51321,
	"./foods/Meat_Fish_Eggs/05147_goose.jpg": 73530,
	"./foods/Meat_Fish_Eggs/05166_turkey.jpg": 96496,
	"./foods/Meat_Fish_Eggs/05306_ground_turkey.jpg": 37590,
	"./foods/Meat_Fish_Eggs/05332_ground_chicken.jpg": 10040,
	"./foods/Meat_Fish_Eggs/07013_bratwurst_pork.jpg": 28076,
	"./foods/Meat_Fish_Eggs/07019_chorizo_sausage.jpg": 54411,
	"./foods/Meat_Fish_Eggs/07029_sliced_ham.jpg": 91683,
	"./foods/Meat_Fish_Eggs/07043_roast_beef_deli_slices.jpg": 40401,
	"./foods/Meat_Fish_Eggs/07050_mortadella.jpg": 10909,
	"./foods/Meat_Fish_Eggs/07052_pastrami.jpg": 37421,
	"./foods/Meat_Fish_Eggs/07057_pepperoni.jpg": 91619,
	"./foods/Meat_Fish_Eggs/07059_polish_sausage.jpg": 20718,
	"./foods/Meat_Fish_Eggs/07063_pork_sausage.jpg": 50274,
	"./foods/Meat_Fish_Eggs/07068_salami.jpg": 97382,
	"./foods/Meat_Fish_Eggs/07078_cervelat_summer_sausage.jpg": 31766,
	"./foods/Meat_Fish_Eggs/07254_turkey_bacon.jpg": 93690,
	"./foods/Meat_Fish_Eggs/07916_smoked_polish_sausage_pork.jpg": 14611,
	"./foods/Meat_Fish_Eggs/07921_beef_sticks.jpg": 23223,
	"./foods/Meat_Fish_Eggs/07922_smoked_bratwurst.jpg": 6986,
	"./foods/Meat_Fish_Eggs/07923_bratwurst_chicken.jpg": 90665,
	"./foods/Meat_Fish_Eggs/07944_turkey_deli_slices.jpg": 40113,
	"./foods/Meat_Fish_Eggs/07950_hot_dog_frankfurter.jpg": 92526,
	"./foods/Meat_Fish_Eggs/07954_breakfast_sausage.jpg": 41626,
	"./foods/Meat_Fish_Eggs/07956_sausage_beef.jpg": 76793,
	"./foods/Meat_Fish_Eggs/07958_turkey_sausage.jpg": 63307,
	"./foods/Meat_Fish_Eggs/07970_kielbasa.jpg": 73263,
	"./foods/Meat_Fish_Eggs/07971_bologna.jpg": 82776,
	"./foods/Meat_Fish_Eggs/10193_ribs_pork.jpg": 22721,
	"./foods/Meat_Fish_Eggs/10220_ground_pork.jpg": 20093,
	"./foods/Meat_Fish_Eggs/10862_bacon.jpg": 41982,
	"./foods/Meat_Fish_Eggs/10922_ham_boneless.jpg": 82216,
	"./foods/Meat_Fish_Eggs/10923_ham_bone_in.jpg": 78300,
	"./foods/Meat_Fish_Eggs/10981_pork_loin.jpg": 35028,
	"./foods/Meat_Fish_Eggs/10988_pork_chops.jpg": 20048,
	"./foods/Meat_Fish_Eggs/10994_bacon_reduced_sodium.jpg": 70273,
	"./foods/Meat_Fish_Eggs/10998_canadian_bacon.jpg": 20098,
	"./foods/Meat_Fish_Eggs/13148_short_ribs_beef.jpg": 21379,
	"./foods/Meat_Fish_Eggs/13347_corned_beef.jpg": 36240,
	"./foods/Meat_Fish_Eggs/13350_cured_beef_dried.jpg": 77111,
	"./foods/Meat_Fish_Eggs/13357_smoked_sausage_beef.jpg": 58951,
	"./foods/Meat_Fish_Eggs/13369_beef_brisket.jpg": 78903,
	"./foods/Meat_Fish_Eggs/13919_beef_tenderloin.jpg": 8868,
	"./foods/Meat_Fish_Eggs/13948_steak_beef.jpg": 31712,
	"./foods/Meat_Fish_Eggs/15029_sole_flounder.jpg": 61372,
	"./foods/Meat_Fish_Eggs/15034_haddock.jpg": 26327,
	"./foods/Meat_Fish_Eggs/15037_halibut.jpg": 851,
	"./foods/Meat_Fish_Eggs/15118_tuna.jpg": 37018,
	"./foods/Meat_Fish_Eggs/15137_alaska_king_crab.jpg": 62183,
	"./foods/Meat_Fish_Eggs/15148_lobster.jpg": 59326,
	"./foods/Meat_Fish_Eggs/15159_clams.jpg": 50701,
	"./foods/Meat_Fish_Eggs/15165_mussels.jpg": 85800,
	"./foods/Meat_Fish_Eggs/15179_smoked_salmon_lox.jpg": 84951,
	"./foods/Meat_Fish_Eggs/15197_herring.jpg": 70438,
	"./foods/Meat_Fish_Eggs/15219_trout.jpg": 38162,
	"./foods/Meat_Fish_Eggs/15226_dungeness_crab.jpg": 13409,
	"./foods/Meat_Fish_Eggs/15237_salmon.jpg": 50304,
	"./foods/Meat_Fish_Eggs/15243_crayfish.jpg": 70754,
	"./foods/Meat_Fish_Eggs/15246_oysters.jpg": 74687,
	"./foods/Meat_Fish_Eggs/15267_pollock.jpg": 3663,
	"./foods/Meat_Fish_Eggs/15269_cod.jpg": 47659,
	"./foods/Meat_Fish_Eggs/15271_shrimp_prawns.jpg": 52617,
	"./foods/Meat_Fish_Eggs/17006_lamb.jpg": 38502,
	"./foods/Meat_Fish_Eggs/17012_lamb_leg.jpg": 95078,
	"./foods/Meat_Fish_Eggs/17060_stewing_lamb.jpg": 95492,
	"./foods/Meat_Fish_Eggs/17148_ground_bison.jpg": 19574,
	"./foods/Meat_Fish_Eggs/23092_stewing_beef.jpg": 53654,
	"./foods/Meat_Fish_Eggs/23113_beef_roast.jpg": 71942,
	"./foods/Meat_Fish_Eggs/23220_ground_beef.jpg": 73411,
	"./foods/Meat_Fish_Eggs/23233_ribs_beef.jpg": 15410,
	"./foods/Meat_Fish_Eggs/43283_pheasant.jpg": 58008,
	"./foods/Meat_Fish_Eggs/90240_scallops.jpg": 16644,
	"./foods/Seasonings_Toppings/02001_allspice_ground.jpg": 48376,
	"./foods/Seasonings_Toppings/02002_anise_seed.jpg": 33058,
	"./foods/Seasonings_Toppings/02003_basil_dried.jpg": 96855,
	"./foods/Seasonings_Toppings/02004_bay_leaf.jpg": 21577,
	"./foods/Seasonings_Toppings/02005_caraway_seed.jpg": 11653,
	"./foods/Seasonings_Toppings/02006_cardamom.jpg": 23288,
	"./foods/Seasonings_Toppings/02007_celery_seed.jpg": 5621,
	"./foods/Seasonings_Toppings/02009_chili_powder.jpg": 11948,
	"./foods/Seasonings_Toppings/02010_cinnamon.jpg": 42730,
	"./foods/Seasonings_Toppings/02011_cloves_ground.jpg": 18886,
	"./foods/Seasonings_Toppings/02012_coriander_leaf_dried.jpg": 72488,
	"./foods/Seasonings_Toppings/02014_cumin_seed.jpg": 20571,
	"./foods/Seasonings_Toppings/02015_curry_powder.jpg": 46631,
	"./foods/Seasonings_Toppings/02017_dill_weed_dried.jpg": 71062,
	"./foods/Seasonings_Toppings/02018_fennel_seed.jpg": 58059,
	"./foods/Seasonings_Toppings/02019_fenugreek_seed.jpg": 14396,
	"./foods/Seasonings_Toppings/02020_garlic_powder.jpg": 37816,
	"./foods/Seasonings_Toppings/02021_ginger_ground.jpg": 5273,
	"./foods/Seasonings_Toppings/02023_marjoram_dried.jpg": 41019,
	"./foods/Seasonings_Toppings/02024_mustard_seed_ground.jpg": 48222,
	"./foods/Seasonings_Toppings/02025_nutmeg_ground.jpg": 45579,
	"./foods/Seasonings_Toppings/02026_onion_powder.jpg": 13739,
	"./foods/Seasonings_Toppings/02027_oregano_dried.jpg": 55385,
	"./foods/Seasonings_Toppings/02028_paprika.jpg": 41542,
	"./foods/Seasonings_Toppings/02029_parsley_dried.jpg": 13968,
	"./foods/Seasonings_Toppings/02030_pepper.jpg": 89817,
	"./foods/Seasonings_Toppings/02031_cayenne.jpg": 5475,
	"./foods/Seasonings_Toppings/02033_poppy_seed.jpg": 47784,
	"./foods/Seasonings_Toppings/02035_pumpkin_pie_spice.jpg": 34560,
	"./foods/Seasonings_Toppings/02036_rosemary_dried.jpg": 12610,
	"./foods/Seasonings_Toppings/02037_saffron.jpg": 54319,
	"./foods/Seasonings_Toppings/02038_sage_ground.jpg": 46639,
	"./foods/Seasonings_Toppings/02041_tarragon_dried.jpg": 166,
	"./foods/Seasonings_Toppings/02042_thyme_dried.jpg": 84684,
	"./foods/Seasonings_Toppings/02043_turmeric_ground.jpg": 9932,
	"./foods/Seasonings_Toppings/02044_basil_fresh.jpg": 84628,
	"./foods/Seasonings_Toppings/02045_dill_weed_fresh.jpg": 11671,
	"./foods/Seasonings_Toppings/02046_mustard_yellow.jpg": 36065,
	"./foods/Seasonings_Toppings/02047_salt_table.jpg": 7542,
	"./foods/Seasonings_Toppings/02048_cider_vinegar.jpg": 99206,
	"./foods/Seasonings_Toppings/02049_thyme_fresh.jpg": 80267,
	"./foods/Seasonings_Toppings/02050_vanilla_extract.jpg": 50080,
	"./foods/Seasonings_Toppings/02053_distilled_vinegar.jpg": 71565,
	"./foods/Seasonings_Toppings/02054_capers.jpg": 67983,
	"./foods/Seasonings_Toppings/02055_horseradish.jpg": 81210,
	"./foods/Seasonings_Toppings/02063_rosemary_fresh.jpg": 29728,
	"./foods/Seasonings_Toppings/02064_peppermint_fresh.jpg": 6793,
	"./foods/Seasonings_Toppings/02065_spearmint_fresh.jpg": 24493,
	"./foods/Seasonings_Toppings/02066_spearmint_dried.jpg": 93822,
	"./foods/Seasonings_Toppings/02068_red_wine_vinegar.jpg": 47912,
	"./foods/Seasonings_Toppings/02069_balsamic_vinegar.jpg": 35710,
	"./foods/Seasonings_Toppings/11156_chives_fresh.jpg": 9815,
	"./foods/Seasonings_Toppings/11215_garlic.jpg": 50120,
	"./foods/Seasonings_Toppings/11216_ginger_root.jpg": 89432,
	"./foods/Seasonings_Toppings/11284_onions_dehydrated_flakes.jpg": 50340,
	"./foods/Seasonings_Toppings/11297_parsley_fresh.jpg": 21345,
	"./foods/Seasonings_Toppings/11439_sauerkraut.jpg": 9941,
	"./foods/Seasonings_Toppings/11677_shallots.jpg": 53552,
	"./foods/Seasonings_Toppings/11935_ketchup_catsup.jpg": 53344,
	"./foods/Seasonings_Toppings/11945_relish_sweet.jpg": 45192,
	"./foods/Seasonings_Toppings/11955_sun_dried_tomatoes.jpg": 89283,
	"./foods/Seasonings_Toppings/11958_relish_pickle.jpg": 98350,
	"./foods/Seasonings_Toppings/16124_soy_sauce.jpg": 83321,
	"./foods/Seasonings_Toppings/43212_bacon_bits_meatless.jpg": 62893,
	"./foods/Seasonings_Toppings/43598_mayonnaise_dressing.jpg": 82485,
	"./foods/Seasonings_Toppings/notlisted_half_salt.jpg": 42464,
	"./foods/Seasonings_Toppings/notlisted_no_salt.jpg": 20018,
	"./foods/Vegetables/11001_alfalfa_sprouts.jpg": 63070,
	"./foods/Vegetables/11007_artichoke.jpg": 99764,
	"./foods/Vegetables/11011_asparagus.jpg": 36360,
	"./foods/Vegetables/11026_bamboo_shoots.jpg": 21648,
	"./foods/Vegetables/11052_green_beans.jpg": 86451,
	"./foods/Vegetables/11080_beets.jpg": 86200,
	"./foods/Vegetables/11086_beet_greens_raw.jpg": 92673,
	"./foods/Vegetables/11087_beet_greens_cooked.jpg": 76691,
	"./foods/Vegetables/11090_broccoli.jpg": 32231,
	"./foods/Vegetables/11098_brussels_sprouts_raw.jpg": 60745,
	"./foods/Vegetables/11099_brussels_sprouts_cooked.jpg": 42185,
	"./foods/Vegetables/11109_cabbage.jpg": 8830,
	"./foods/Vegetables/11116_bok_choy_raw.jpg": 11030,
	"./foods/Vegetables/11117_bok_choy_cooked.jpg": 25724,
	"./foods/Vegetables/11118_kimchi.jpg": 44828,
	"./foods/Vegetables/11124_carrots.jpg": 38932,
	"./foods/Vegetables/11135_cauliflower.jpg": 82291,
	"./foods/Vegetables/11141_celeriac.jpg": 87657,
	"./foods/Vegetables/11143_celery.jpg": 74259,
	"./foods/Vegetables/11147_swiss_chard_raw.jpg": 58562,
	"./foods/Vegetables/11148_swiss_chard_cooked.jpg": 30112,
	"./foods/Vegetables/11156_chives.jpg": 67363,
	"./foods/Vegetables/11161_collards_raw.jpg": 12590,
	"./foods/Vegetables/11162_collards_cooked.jpg": 79358,
	"./foods/Vegetables/11165_coriander_cilantro.jpg": 54643,
	"./foods/Vegetables/11167_corn.jpg": 79138,
	"./foods/Vegetables/11203_garden_cress.jpg": 86788,
	"./foods/Vegetables/11205_cucumber.jpg": 7470,
	"./foods/Vegetables/11207_dandelion_greens_raw.jpg": 94762,
	"./foods/Vegetables/11208_dandelion_greens_cooked.jpg": 97490,
	"./foods/Vegetables/11210_eggplant.jpg": 75910,
	"./foods/Vegetables/11211_edamame_frozen.jpg": 23186,
	"./foods/Vegetables/11213_endive_raw.jpg": 93101,
	"./foods/Vegetables/11215_garlic.jpg": 793,
	"./foods/Vegetables/11216_ginger_root.jpg": 85835,
	"./foods/Vegetables/11233_kale_raw.jpg": 43725,
	"./foods/Vegetables/11234_kale_cooked.jpg": 26523,
	"./foods/Vegetables/11241_kohlrabi.jpg": 35908,
	"./foods/Vegetables/11246_leeks.jpg": 89343,
	"./foods/Vegetables/11251_romaine_lettuce.jpg": 28683,
	"./foods/Vegetables/11260_white_mushrooms_raw.jpg": 46167,
	"./foods/Vegetables/11261_white_mushrooms_cooked.jpg": 69873,
	"./foods/Vegetables/11265_portabella_mushrooms_raw.jpg": 14793,
	"./foods/Vegetables/11270_mustard_greens_raw.jpg": 18692,
	"./foods/Vegetables/11271_mustard_greens_cooked.jpg": 43482,
	"./foods/Vegetables/11278_okra.jpg": 47023,
	"./foods/Vegetables/11282_onions.jpg": 6237,
	"./foods/Vegetables/11284_onions_dehydrated.jpg": 35690,
	"./foods/Vegetables/11297_parsley_fresh.jpg": 24578,
	"./foods/Vegetables/11298_parsnips.jpg": 79864,
	"./foods/Vegetables/11304_green_peas.jpg": 92015,
	"./foods/Vegetables/11333_green_peppers.jpg": 11593,
	"./foods/Vegetables/11352_potatoes_raw.jpg": 59599,
	"./foods/Vegetables/11357_potatoes_baked.jpg": 58647,
	"./foods/Vegetables/11365_potatoes_mashed.jpg": 42503,
	"./foods/Vegetables/11422_pumpkin.jpg": 46315,
	"./foods/Vegetables/11429_radishes.jpg": 11101,
	"./foods/Vegetables/11435_rutabagas.jpg": 2459,
	"./foods/Vegetables/11439_sauerkraut.jpg": 80616,
	"./foods/Vegetables/11457_spinach_raw.jpg": 68584,
	"./foods/Vegetables/11458_spinach_cooked.jpg": 99262,
	"./foods/Vegetables/11477_zucchini.jpg": 71982,
	"./foods/Vegetables/11482_acorn_squash.jpg": 14392,
	"./foods/Vegetables/11485_butternut_squash.jpg": 83201,
	"./foods/Vegetables/11492_spaghetti_squash.jpg": 99179,
	"./foods/Vegetables/11507_sweet_potato.jpg": 76047,
	"./foods/Vegetables/11529_tomatoes_raw.jpg": 53948,
	"./foods/Vegetables/11530_tomatoes_cooked.jpg": 60661,
	"./foods/Vegetables/11564_turnips.jpg": 78473,
	"./foods/Vegetables/11588_water_chestnuts.jpg": 17613,
	"./foods/Vegetables/11591_watercress.jpg": 88151,
	"./foods/Vegetables/11601_yams.jpg": 36792,
	"./foods/Vegetables/11603_jicama.jpg": 94141,
	"./foods/Vegetables/11670_hot_chili_peppers.jpg": 57677,
	"./foods/Vegetables/11677_shallots.jpg": 42537,
	"./foods/Vegetables/11722_yellow_beans.jpg": 62166,
	"./foods/Vegetables/11821_red_peppers.jpg": 86511,
	"./foods/Vegetables/11935_ketchup_catsup.jpg": 64181,
	"./foods/Vegetables/11937_dill_pickles.jpg": 15547,
	"./foods/Vegetables/11940_sweet_pickles.jpg": 6542,
	"./foods/Vegetables/11945_relish_sweet.jpg": 66937,
	"./foods/Vegetables/11952_radicchio.jpg": 25355,
	"./foods/Vegetables/11955_sundried_tomatoes.jpg": 88343,
	"./foods/Vegetables/11957_fennel.jpg": 45236,
	"./foods/Vegetables/11958_relish_pickle.jpg": 76721,
	"./foods/Vegetables/11959_arugula.jpg": 57955,
	"./foods/Vegetables/11972_lemon_grass.jpg": 60895,
	"./foods/Vegetables/11974_grape_leaves.jpg": 31271,
	"./foods/Vegetables/11976_banana_peppers.jpg": 10248,
	"./foods/Vegetables/11979_jalapeno_peppers.jpg": 12408,
	"./foods/Vegetables/11981_hungarian_peppers.jpg": 43686,
	"./foods/Vegetables/43143_pickled_cabbage.jpg": 35044,
	"./foods/Vegetables/43146_eggplant_pickled.jpg": 93646,
	"images/foods/Beans_Nuts_Legumes/12006_chia_seeds.jpg": 8871,
	"images/foods/Beans_Nuts_Legumes/12012_hemp_seeds.jpg": 28939,
	"images/foods/Beans_Nuts_Legumes/12016_pumpkin_seeds_unsalted.jpg": 97606,
	"images/foods/Beans_Nuts_Legumes/12029_sesame_seeds_unsalted.jpg": 78448,
	"images/foods/Beans_Nuts_Legumes/12061_almonds_unsalted.jpg": 19901,
	"images/foods/Beans_Nuts_Legumes/12078_brazil_nuts_unsalted.jpg": 45516,
	"images/foods/Beans_Nuts_Legumes/12085_cashews_unsalted.jpg": 20747,
	"images/foods/Beans_Nuts_Legumes/12104_coconut_raw.jpg": 23662,
	"images/foods/Beans_Nuts_Legumes/12119_coconut_water.jpg": 75339,
	"images/foods/Beans_Nuts_Legumes/12120_hazelnuts_filberts.jpg": 83950,
	"images/foods/Beans_Nuts_Legumes/12132_macademia_nuts_unsalted.jpg": 43161,
	"images/foods/Beans_Nuts_Legumes/12142_pecans_unsalted.jpg": 98847,
	"images/foods/Beans_Nuts_Legumes/12147_pine_nuts_unsalted.jpg": 5009,
	"images/foods/Beans_Nuts_Legumes/12152_pistachio_nuts_salted.jpg": 97472,
	"images/foods/Beans_Nuts_Legumes/12155_walnuts_unsalted.jpg": 55569,
	"images/foods/Beans_Nuts_Legumes/12179_coconut_sweetened.jpg": 93502,
	"images/foods/Beans_Nuts_Legumes/12195_almond_butter_unsalted.jpg": 52471,
	"images/foods/Beans_Nuts_Legumes/12220_flaxseed.jpg": 99075,
	"images/foods/Beans_Nuts_Legumes/12516_pumpkin_seeds_salted.jpg": 56504,
	"images/foods/Beans_Nuts_Legumes/12529_sesame_seeds_salted.jpg": 95020,
	"images/foods/Beans_Nuts_Legumes/12563_almonds_salted.jpg": 47641,
	"images/foods/Beans_Nuts_Legumes/12585_cashews_salted.jpg": 83377,
	"images/foods/Beans_Nuts_Legumes/12632_macademia_nuts_salted.jpg": 56015,
	"images/foods/Beans_Nuts_Legumes/12652_pistachio_nuts_unsalted.jpg": 15014,
	"images/foods/Beans_Nuts_Legumes/12663_pumpkin_seeds_whole_salted.jpg": 26225,
	"images/foods/Beans_Nuts_Legumes/16002_adzuki_beans.jpg": 6647,
	"images/foods/Beans_Nuts_Legumes/16005_baked_beans.jpg": 83917,
	"images/foods/Beans_Nuts_Legumes/16028_kidney_beans.jpg": 7207,
	"images/foods/Beans_Nuts_Legumes/16038_navy_beans.jpg": 95542,
	"images/foods/Beans_Nuts_Legumes/16043_pinto_beans.jpg": 1476,
	"images/foods/Beans_Nuts_Legumes/16053_broad_beans.jpg": 93797,
	"images/foods/Beans_Nuts_Legumes/16057_chickpeas.jpg": 84116,
	"images/foods/Beans_Nuts_Legumes/16070_lentils.jpg": 30403,
	"images/foods/Beans_Nuts_Legumes/16072_lima_beans.jpg": 44875,
	"images/foods/Beans_Nuts_Legumes/16086_split_peas.jpg": 62593,
	"images/foods/Beans_Nuts_Legumes/16089_peanuts_salted.jpg": 15996,
	"images/foods/Beans_Nuts_Legumes/16114_tempeh.jpg": 60654,
	"images/foods/Beans_Nuts_Legumes/16124_soy_sauce.jpg": 50589,
	"images/foods/Beans_Nuts_Legumes/16157_chickpea_flour.jpg": 77753,
	"images/foods/Beans_Nuts_Legumes/16389_peanuts_unsalted.jpg": 72868,
	"images/foods/Beans_Nuts_Legumes/16398_peanut_butter_natural_unsalted.jpg": 30750,
	"images/foods/Beans_Nuts_Legumes/16427_tofu.jpg": 49190,
	"images/foods/Beans_Nuts_Legumes/43212_meatless_bacon_bits.jpg": 74473,
	"images/foods/Dairy/01004_blue_cheese.jpg": 22367,
	"images/foods/Dairy/01006_brie_cheese.jpg": 64127,
	"images/foods/Dairy/01007_camembert_cheese.jpg": 94468,
	"images/foods/Dairy/01009_cheddar_cheese.jpg": 5025,
	"images/foods/Dairy/01012_cottage_cheese.jpg": 59045,
	"images/foods/Dairy/01017_cream_cheese.jpg": 61213,
	"images/foods/Dairy/01019_feta_cheese.jpg": 78995,
	"images/foods/Dairy/01022_gouda_cheese.jpg": 84225,
	"images/foods/Dairy/01023_gruyere_cheese.jpg": 62663,
	"images/foods/Dairy/01026_mozzarella_cheese.jpg": 9958,
	"images/foods/Dairy/01033_parmesan_cheese.jpg": 92068,
	"images/foods/Dairy/01035_provolone_cheese.jpg": 62435,
	"images/foods/Dairy/01036_roicotta_cheese.jpg": 74847,
	"images/foods/Dairy/01040_swiss_cheese.jpg": 47120,
	"images/foods/Dairy/01049_cream_half.jpg": 13082,
	"images/foods/Dairy/01052_whipping_cream.jpg": 87513,
	"images/foods/Dairy/01056_sour_cream.jpg": 41256,
	"images/foods/Dairy/01077_whole_milk.jpg": 13436,
	"images/foods/Dairy/01082_milk_one_percent.jpg": 81503,
	"images/foods/Dairy/01116_yogurt_plain_whole_milk.jpg": 20740,
	"images/foods/Dairy/01117_yogurt_plain_low_fat.jpg": 46888,
	"images/foods/Dairy/01159_goat_cheese.jpg": 89771,
	"images/foods/Dairy/01236_ice_cream.jpg": 64000,
	"images/foods/Fats_Oils/04002_lard.jpg": 58900,
	"images/foods/Fats_Oils/04600_margarine.jpg": 99911,
	"images/foods/Fats_Oils/04601_butter_salted.jpg": 31412,
	"images/foods/Fats_Oils/04602_butter_unsalted.jpg": 31870,
	"images/foods/Fats_Oils/04615_vegetable_shortening.jpg": 7048,
	"images/foods/Fats_Oils/43598_mayonnaise.jpg": 10036,
	"images/foods/Fats_Oils/notlisted_cooking_oils.jpg": 45025,
	"images/foods/Fruits/09004_apples.jpg": 17824,
	"images/foods/Fruits/09011_apples_dried.jpg": 86923,
	"images/foods/Fruits/09021_apricots.jpg": 6127,
	"images/foods/Fruits/09032_apricots_dried.jpg": 5870,
	"images/foods/Fruits/09037_avocados.jpg": 77687,
	"images/foods/Fruits/09040_bananas.jpg": 96373,
	"images/foods/Fruits/09041_dehydrated_bananas.jpg": 20433,
	"images/foods/Fruits/09042_blackberries.jpg": 53466,
	"images/foods/Fruits/09050_blueberries.jpg": 36156,
	"images/foods/Fruits/09060_starfruit.jpg": 84171,
	"images/foods/Fruits/09063_sour_cherries.jpg": 27099,
	"images/foods/Fruits/09070_sweet_cherries.jpg": 85580,
	"images/foods/Fruits/09077_crabapples.jpg": 22692,
	"images/foods/Fruits/09078_cranberries.jpg": 63600,
	"images/foods/Fruits/09079_dried_cranberries.jpg": 62044,
	"images/foods/Fruits/09088_elderberries.jpg": 95955,
	"images/foods/Fruits/09089_figs.jpg": 48057,
	"images/foods/Fruits/09094_figs_dried.jpg": 37330,
	"images/foods/Fruits/09107_gooseberries.jpg": 27682,
	"images/foods/Fruits/09111_grapefruit.jpg": 98791,
	"images/foods/Fruits/09132_grapes.jpg": 59493,
	"images/foods/Fruits/09139_guava.jpg": 64040,
	"images/foods/Fruits/09144_jackfruit.jpg": 89767,
	"images/foods/Fruits/09148_kiwi.jpg": 52572,
	"images/foods/Fruits/09150_lemons.jpg": 1361,
	"images/foods/Fruits/09159_limes.jpg": 18310,
	"images/foods/Fruits/09163_blueberries_dried.jpg": 49322,
	"images/foods/Fruits/09164_litchis.jpg": 54594,
	"images/foods/Fruits/09176_mangos.jpg": 66788,
	"images/foods/Fruits/09181_cantaloupe.jpg": 7011,
	"images/foods/Fruits/09184_honeydew_melon.jpg": 4607,
	"images/foods/Fruits/09190_mulberries.jpg": 95543,
	"images/foods/Fruits/09191_nectarines.jpg": 40764,
	"images/foods/Fruits/09195_olives.jpg": 11306,
	"images/foods/Fruits/09200_oranges.jpg": 8524,
	"images/foods/Fruits/09218_tangerines_mandarin.jpg": 11433,
	"images/foods/Fruits/09226_papayas.jpg": 24380,
	"images/foods/Fruits/09231_passion_fruit.jpg": 18037,
	"images/foods/Fruits/09236_peaches.jpg": 55309,
	"images/foods/Fruits/09246_peaches_dried.jpg": 93545,
	"images/foods/Fruits/09252_pears.jpg": 28695,
	"images/foods/Fruits/09259_pears_dried.jpg": 78977,
	"images/foods/Fruits/09263_persimmons.jpg": 15221,
	"images/foods/Fruits/09266_pineapple.jpg": 29155,
	"images/foods/Fruits/09279_plums.jpg": 5116,
	"images/foods/Fruits/09286_pomegranates.jpg": 12759,
	"images/foods/Fruits/09287_prickly_pears.jpg": 51828,
	"images/foods/Fruits/09289_prunes_dehydrated.jpg": 75384,
	"images/foods/Fruits/09291_plums_dried.jpg": 94343,
	"images/foods/Fruits/09295_pummelo.jpg": 41892,
	"images/foods/Fruits/09299_raisins.jpg": 5658,
	"images/foods/Fruits/09302_raspberries.jpg": 79900,
	"images/foods/Fruits/09307_rhubarb.jpg": 46471,
	"images/foods/Fruits/09316_strawberries.jpg": 70674,
	"images/foods/Fruits/09322_tamarinds.jpg": 18597,
	"images/foods/Fruits/09326_watermelon.jpg": 74252,
	"images/foods/Fruits/09340_asian_pears.jpg": 64854,
	"images/foods/Fruits/09421_medjool_dates.jpg": 64424,
	"images/foods/Fruits/09422_durian.jpg": 19376,
	"images/foods/Fruits/09433_clementine.jpg": 98605,
	"images/foods/Fruits/09451_horned_melon.jpg": 1057,
	"images/foods/Fruits/09542_plantains.jpg": 20080,
	"images/foods/Grains/18041_pita_bread.jpg": 30674,
	"images/foods/Grains/18060_rye_bread.jpg": 76481,
	"images/foods/Grains/18064_bread_whole_wheat.jpg": 72700,
	"images/foods/Grains/18079_bread_crumbs.jpg": 30023,
	"images/foods/Grains/18248_doughnuts.jpg": 36975,
	"images/foods/Grains/18342_dinner_rolls.jpg": 32700,
	"images/foods/Grains/18350_hamburger_hot_dog_rolls.jpg": 37291,
	"images/foods/Grains/18370_baking_powder.jpg": 82024,
	"images/foods/Grains/18371_baking_powder_low_sodium.jpg": 95442,
	"images/foods/Grains/18372_baking_soda.jpg": 5246,
	"images/foods/Grains/18373_cream_of_tartar.jpg": 40394,
	"images/foods/Grains/18375_baker's_yeast.jpg": 61177,
	"images/foods/Grains/18407_bagel_plain.jpg": 48095,
	"images/foods/Grains/18967_bread_white.jpg": 94620,
	"images/foods/Grains/18968_bagel_whole_wheat.jpg": 49982,
	"images/foods/Grains/18972_cheese_bread.jpg": 55020,
	"images/foods/Grains/18973_focaccia.jpg": 86138,
	"images/foods/Grains/20006_pearl_barley.jpg": 49709,
	"images/foods/Grains/20008_buckwheat.jpg": 42061,
	"images/foods/Grains/20013_bulgur.jpg": 9190,
	"images/foods/Grains/20017_corn_flour.jpg": 22372,
	"images/foods/Grains/20027_cornstarch.jpg": 29983,
	"images/foods/Grains/20029_couscous.jpg": 37930,
	"images/foods/Grains/20032_millet.jpg": 1687,
	"images/foods/Grains/20034_oat_bran.jpg": 53026,
	"images/foods/Grains/20037_brown_rice.jpg": 27625,
	"images/foods/Grains/20038_oats.jpg": 60247,
	"images/foods/Grains/20055_white_rice.jpg": 45768,
	"images/foods/Grains/20080_wheat_flour.jpg": 56691,
	"images/foods/Grains/20081_all_puprose_flour.jpg": 16709,
	"images/foods/Grains/20089_wild_rice.jpg": 34170,
	"images/foods/Grains/20090_brown_rice_flour.jpg": 45355,
	"images/foods/Grains/20109_egg_noodles.jpg": 35905,
	"images/foods/Grains/20115_soba_noodles.jpg": 90222,
	"images/foods/Grains/20121_pasta_without_added_salt.jpg": 24351,
	"images/foods/Grains/20130_barley_flour.jpg": 4145,
	"images/foods/Grains/20134_rice_noodles.jpg": 34141,
	"images/foods/Grains/20137_quinoa.jpg": 98133,
	"images/foods/Grains/20322_cornmeal.jpg": 33081,
	"images/foods/Grains/28306_chapati_roti.jpg": 66921,
	"images/foods/Grains/28307_naan.jpg": 64481,
	"images/foods/Grains/28315_cinnamon_bread.jpg": 58970,
	"images/foods/Grains/28320_english_muffins.jpg": 51505,
	"images/foods/Meat_Fish_Eggs/01124_egg_whites.jpg": 47520,
	"images/foods/Meat_Fish_Eggs/01128_egg_whole.jpg": 52405,
	"images/foods/Meat_Fish_Eggs/05026_chicken_hearts.jpg": 72942,
	"images/foods/Meat_Fish_Eggs/05027_chicken_livers.jpg": 89609,
	"images/foods/Meat_Fish_Eggs/05112_roasted_chicken.jpg": 69797,
	"images/foods/Meat_Fish_Eggs/05140_duck.jpg": 51321,
	"images/foods/Meat_Fish_Eggs/05147_goose.jpg": 73530,
	"images/foods/Meat_Fish_Eggs/05166_turkey.jpg": 96496,
	"images/foods/Meat_Fish_Eggs/05306_ground_turkey.jpg": 37590,
	"images/foods/Meat_Fish_Eggs/05332_ground_chicken.jpg": 10040,
	"images/foods/Meat_Fish_Eggs/07013_bratwurst_pork.jpg": 28076,
	"images/foods/Meat_Fish_Eggs/07019_chorizo_sausage.jpg": 54411,
	"images/foods/Meat_Fish_Eggs/07029_sliced_ham.jpg": 91683,
	"images/foods/Meat_Fish_Eggs/07043_roast_beef_deli_slices.jpg": 40401,
	"images/foods/Meat_Fish_Eggs/07050_mortadella.jpg": 10909,
	"images/foods/Meat_Fish_Eggs/07052_pastrami.jpg": 37421,
	"images/foods/Meat_Fish_Eggs/07057_pepperoni.jpg": 91619,
	"images/foods/Meat_Fish_Eggs/07059_polish_sausage.jpg": 20718,
	"images/foods/Meat_Fish_Eggs/07063_pork_sausage.jpg": 50274,
	"images/foods/Meat_Fish_Eggs/07068_salami.jpg": 97382,
	"images/foods/Meat_Fish_Eggs/07078_cervelat_summer_sausage.jpg": 31766,
	"images/foods/Meat_Fish_Eggs/07254_turkey_bacon.jpg": 93690,
	"images/foods/Meat_Fish_Eggs/07916_smoked_polish_sausage_pork.jpg": 14611,
	"images/foods/Meat_Fish_Eggs/07921_beef_sticks.jpg": 23223,
	"images/foods/Meat_Fish_Eggs/07922_smoked_bratwurst.jpg": 6986,
	"images/foods/Meat_Fish_Eggs/07923_bratwurst_chicken.jpg": 90665,
	"images/foods/Meat_Fish_Eggs/07944_turkey_deli_slices.jpg": 40113,
	"images/foods/Meat_Fish_Eggs/07950_hot_dog_frankfurter.jpg": 92526,
	"images/foods/Meat_Fish_Eggs/07954_breakfast_sausage.jpg": 41626,
	"images/foods/Meat_Fish_Eggs/07956_sausage_beef.jpg": 76793,
	"images/foods/Meat_Fish_Eggs/07958_turkey_sausage.jpg": 63307,
	"images/foods/Meat_Fish_Eggs/07970_kielbasa.jpg": 73263,
	"images/foods/Meat_Fish_Eggs/07971_bologna.jpg": 82776,
	"images/foods/Meat_Fish_Eggs/10193_ribs_pork.jpg": 22721,
	"images/foods/Meat_Fish_Eggs/10220_ground_pork.jpg": 20093,
	"images/foods/Meat_Fish_Eggs/10862_bacon.jpg": 41982,
	"images/foods/Meat_Fish_Eggs/10922_ham_boneless.jpg": 82216,
	"images/foods/Meat_Fish_Eggs/10923_ham_bone_in.jpg": 78300,
	"images/foods/Meat_Fish_Eggs/10981_pork_loin.jpg": 35028,
	"images/foods/Meat_Fish_Eggs/10988_pork_chops.jpg": 20048,
	"images/foods/Meat_Fish_Eggs/10994_bacon_reduced_sodium.jpg": 70273,
	"images/foods/Meat_Fish_Eggs/10998_canadian_bacon.jpg": 20098,
	"images/foods/Meat_Fish_Eggs/13148_short_ribs_beef.jpg": 21379,
	"images/foods/Meat_Fish_Eggs/13347_corned_beef.jpg": 36240,
	"images/foods/Meat_Fish_Eggs/13350_cured_beef_dried.jpg": 77111,
	"images/foods/Meat_Fish_Eggs/13357_smoked_sausage_beef.jpg": 58951,
	"images/foods/Meat_Fish_Eggs/13369_beef_brisket.jpg": 78903,
	"images/foods/Meat_Fish_Eggs/13919_beef_tenderloin.jpg": 8868,
	"images/foods/Meat_Fish_Eggs/13948_steak_beef.jpg": 31712,
	"images/foods/Meat_Fish_Eggs/15029_sole_flounder.jpg": 61372,
	"images/foods/Meat_Fish_Eggs/15034_haddock.jpg": 26327,
	"images/foods/Meat_Fish_Eggs/15037_halibut.jpg": 851,
	"images/foods/Meat_Fish_Eggs/15118_tuna.jpg": 37018,
	"images/foods/Meat_Fish_Eggs/15137_alaska_king_crab.jpg": 62183,
	"images/foods/Meat_Fish_Eggs/15148_lobster.jpg": 59326,
	"images/foods/Meat_Fish_Eggs/15159_clams.jpg": 50701,
	"images/foods/Meat_Fish_Eggs/15165_mussels.jpg": 85800,
	"images/foods/Meat_Fish_Eggs/15179_smoked_salmon_lox.jpg": 84951,
	"images/foods/Meat_Fish_Eggs/15197_herring.jpg": 70438,
	"images/foods/Meat_Fish_Eggs/15219_trout.jpg": 38162,
	"images/foods/Meat_Fish_Eggs/15226_dungeness_crab.jpg": 13409,
	"images/foods/Meat_Fish_Eggs/15237_salmon.jpg": 50304,
	"images/foods/Meat_Fish_Eggs/15243_crayfish.jpg": 70754,
	"images/foods/Meat_Fish_Eggs/15246_oysters.jpg": 74687,
	"images/foods/Meat_Fish_Eggs/15267_pollock.jpg": 3663,
	"images/foods/Meat_Fish_Eggs/15269_cod.jpg": 47659,
	"images/foods/Meat_Fish_Eggs/15271_shrimp_prawns.jpg": 52617,
	"images/foods/Meat_Fish_Eggs/17006_lamb.jpg": 38502,
	"images/foods/Meat_Fish_Eggs/17012_lamb_leg.jpg": 95078,
	"images/foods/Meat_Fish_Eggs/17060_stewing_lamb.jpg": 95492,
	"images/foods/Meat_Fish_Eggs/17148_ground_bison.jpg": 19574,
	"images/foods/Meat_Fish_Eggs/23092_stewing_beef.jpg": 53654,
	"images/foods/Meat_Fish_Eggs/23113_beef_roast.jpg": 71942,
	"images/foods/Meat_Fish_Eggs/23220_ground_beef.jpg": 73411,
	"images/foods/Meat_Fish_Eggs/23233_ribs_beef.jpg": 15410,
	"images/foods/Meat_Fish_Eggs/43283_pheasant.jpg": 58008,
	"images/foods/Meat_Fish_Eggs/90240_scallops.jpg": 16644,
	"images/foods/Seasonings_Toppings/02001_allspice_ground.jpg": 48376,
	"images/foods/Seasonings_Toppings/02002_anise_seed.jpg": 33058,
	"images/foods/Seasonings_Toppings/02003_basil_dried.jpg": 96855,
	"images/foods/Seasonings_Toppings/02004_bay_leaf.jpg": 21577,
	"images/foods/Seasonings_Toppings/02005_caraway_seed.jpg": 11653,
	"images/foods/Seasonings_Toppings/02006_cardamom.jpg": 23288,
	"images/foods/Seasonings_Toppings/02007_celery_seed.jpg": 5621,
	"images/foods/Seasonings_Toppings/02009_chili_powder.jpg": 11948,
	"images/foods/Seasonings_Toppings/02010_cinnamon.jpg": 42730,
	"images/foods/Seasonings_Toppings/02011_cloves_ground.jpg": 18886,
	"images/foods/Seasonings_Toppings/02012_coriander_leaf_dried.jpg": 72488,
	"images/foods/Seasonings_Toppings/02014_cumin_seed.jpg": 20571,
	"images/foods/Seasonings_Toppings/02015_curry_powder.jpg": 46631,
	"images/foods/Seasonings_Toppings/02017_dill_weed_dried.jpg": 71062,
	"images/foods/Seasonings_Toppings/02018_fennel_seed.jpg": 58059,
	"images/foods/Seasonings_Toppings/02019_fenugreek_seed.jpg": 14396,
	"images/foods/Seasonings_Toppings/02020_garlic_powder.jpg": 37816,
	"images/foods/Seasonings_Toppings/02021_ginger_ground.jpg": 5273,
	"images/foods/Seasonings_Toppings/02023_marjoram_dried.jpg": 41019,
	"images/foods/Seasonings_Toppings/02024_mustard_seed_ground.jpg": 48222,
	"images/foods/Seasonings_Toppings/02025_nutmeg_ground.jpg": 45579,
	"images/foods/Seasonings_Toppings/02026_onion_powder.jpg": 13739,
	"images/foods/Seasonings_Toppings/02027_oregano_dried.jpg": 55385,
	"images/foods/Seasonings_Toppings/02028_paprika.jpg": 41542,
	"images/foods/Seasonings_Toppings/02029_parsley_dried.jpg": 13968,
	"images/foods/Seasonings_Toppings/02030_pepper.jpg": 89817,
	"images/foods/Seasonings_Toppings/02031_cayenne.jpg": 5475,
	"images/foods/Seasonings_Toppings/02033_poppy_seed.jpg": 47784,
	"images/foods/Seasonings_Toppings/02035_pumpkin_pie_spice.jpg": 34560,
	"images/foods/Seasonings_Toppings/02036_rosemary_dried.jpg": 12610,
	"images/foods/Seasonings_Toppings/02037_saffron.jpg": 54319,
	"images/foods/Seasonings_Toppings/02038_sage_ground.jpg": 46639,
	"images/foods/Seasonings_Toppings/02041_tarragon_dried.jpg": 166,
	"images/foods/Seasonings_Toppings/02042_thyme_dried.jpg": 84684,
	"images/foods/Seasonings_Toppings/02043_turmeric_ground.jpg": 9932,
	"images/foods/Seasonings_Toppings/02044_basil_fresh.jpg": 84628,
	"images/foods/Seasonings_Toppings/02045_dill_weed_fresh.jpg": 11671,
	"images/foods/Seasonings_Toppings/02046_mustard_yellow.jpg": 36065,
	"images/foods/Seasonings_Toppings/02047_salt_table.jpg": 7542,
	"images/foods/Seasonings_Toppings/02048_cider_vinegar.jpg": 99206,
	"images/foods/Seasonings_Toppings/02049_thyme_fresh.jpg": 80267,
	"images/foods/Seasonings_Toppings/02050_vanilla_extract.jpg": 50080,
	"images/foods/Seasonings_Toppings/02053_distilled_vinegar.jpg": 71565,
	"images/foods/Seasonings_Toppings/02054_capers.jpg": 67983,
	"images/foods/Seasonings_Toppings/02055_horseradish.jpg": 81210,
	"images/foods/Seasonings_Toppings/02063_rosemary_fresh.jpg": 29728,
	"images/foods/Seasonings_Toppings/02064_peppermint_fresh.jpg": 6793,
	"images/foods/Seasonings_Toppings/02065_spearmint_fresh.jpg": 24493,
	"images/foods/Seasonings_Toppings/02066_spearmint_dried.jpg": 93822,
	"images/foods/Seasonings_Toppings/02068_red_wine_vinegar.jpg": 47912,
	"images/foods/Seasonings_Toppings/02069_balsamic_vinegar.jpg": 35710,
	"images/foods/Seasonings_Toppings/11156_chives_fresh.jpg": 9815,
	"images/foods/Seasonings_Toppings/11215_garlic.jpg": 50120,
	"images/foods/Seasonings_Toppings/11216_ginger_root.jpg": 89432,
	"images/foods/Seasonings_Toppings/11284_onions_dehydrated_flakes.jpg": 50340,
	"images/foods/Seasonings_Toppings/11297_parsley_fresh.jpg": 21345,
	"images/foods/Seasonings_Toppings/11439_sauerkraut.jpg": 9941,
	"images/foods/Seasonings_Toppings/11677_shallots.jpg": 53552,
	"images/foods/Seasonings_Toppings/11935_ketchup_catsup.jpg": 53344,
	"images/foods/Seasonings_Toppings/11945_relish_sweet.jpg": 45192,
	"images/foods/Seasonings_Toppings/11955_sun_dried_tomatoes.jpg": 89283,
	"images/foods/Seasonings_Toppings/11958_relish_pickle.jpg": 98350,
	"images/foods/Seasonings_Toppings/16124_soy_sauce.jpg": 83321,
	"images/foods/Seasonings_Toppings/43212_bacon_bits_meatless.jpg": 62893,
	"images/foods/Seasonings_Toppings/43598_mayonnaise_dressing.jpg": 82485,
	"images/foods/Seasonings_Toppings/notlisted_half_salt.jpg": 42464,
	"images/foods/Seasonings_Toppings/notlisted_no_salt.jpg": 20018,
	"images/foods/Vegetables/11001_alfalfa_sprouts.jpg": 63070,
	"images/foods/Vegetables/11007_artichoke.jpg": 99764,
	"images/foods/Vegetables/11011_asparagus.jpg": 36360,
	"images/foods/Vegetables/11026_bamboo_shoots.jpg": 21648,
	"images/foods/Vegetables/11052_green_beans.jpg": 86451,
	"images/foods/Vegetables/11080_beets.jpg": 86200,
	"images/foods/Vegetables/11086_beet_greens_raw.jpg": 92673,
	"images/foods/Vegetables/11087_beet_greens_cooked.jpg": 76691,
	"images/foods/Vegetables/11090_broccoli.jpg": 32231,
	"images/foods/Vegetables/11098_brussels_sprouts_raw.jpg": 60745,
	"images/foods/Vegetables/11099_brussels_sprouts_cooked.jpg": 42185,
	"images/foods/Vegetables/11109_cabbage.jpg": 8830,
	"images/foods/Vegetables/11116_bok_choy_raw.jpg": 11030,
	"images/foods/Vegetables/11117_bok_choy_cooked.jpg": 25724,
	"images/foods/Vegetables/11118_kimchi.jpg": 44828,
	"images/foods/Vegetables/11124_carrots.jpg": 38932,
	"images/foods/Vegetables/11135_cauliflower.jpg": 82291,
	"images/foods/Vegetables/11141_celeriac.jpg": 87657,
	"images/foods/Vegetables/11143_celery.jpg": 74259,
	"images/foods/Vegetables/11147_swiss_chard_raw.jpg": 58562,
	"images/foods/Vegetables/11148_swiss_chard_cooked.jpg": 30112,
	"images/foods/Vegetables/11156_chives.jpg": 67363,
	"images/foods/Vegetables/11161_collards_raw.jpg": 12590,
	"images/foods/Vegetables/11162_collards_cooked.jpg": 79358,
	"images/foods/Vegetables/11165_coriander_cilantro.jpg": 54643,
	"images/foods/Vegetables/11167_corn.jpg": 79138,
	"images/foods/Vegetables/11203_garden_cress.jpg": 86788,
	"images/foods/Vegetables/11205_cucumber.jpg": 7470,
	"images/foods/Vegetables/11207_dandelion_greens_raw.jpg": 94762,
	"images/foods/Vegetables/11208_dandelion_greens_cooked.jpg": 97490,
	"images/foods/Vegetables/11210_eggplant.jpg": 75910,
	"images/foods/Vegetables/11211_edamame_frozen.jpg": 23186,
	"images/foods/Vegetables/11213_endive_raw.jpg": 93101,
	"images/foods/Vegetables/11215_garlic.jpg": 793,
	"images/foods/Vegetables/11216_ginger_root.jpg": 85835,
	"images/foods/Vegetables/11233_kale_raw.jpg": 43725,
	"images/foods/Vegetables/11234_kale_cooked.jpg": 26523,
	"images/foods/Vegetables/11241_kohlrabi.jpg": 35908,
	"images/foods/Vegetables/11246_leeks.jpg": 89343,
	"images/foods/Vegetables/11251_romaine_lettuce.jpg": 28683,
	"images/foods/Vegetables/11260_white_mushrooms_raw.jpg": 46167,
	"images/foods/Vegetables/11261_white_mushrooms_cooked.jpg": 69873,
	"images/foods/Vegetables/11265_portabella_mushrooms_raw.jpg": 14793,
	"images/foods/Vegetables/11270_mustard_greens_raw.jpg": 18692,
	"images/foods/Vegetables/11271_mustard_greens_cooked.jpg": 43482,
	"images/foods/Vegetables/11278_okra.jpg": 47023,
	"images/foods/Vegetables/11282_onions.jpg": 6237,
	"images/foods/Vegetables/11284_onions_dehydrated.jpg": 35690,
	"images/foods/Vegetables/11297_parsley_fresh.jpg": 24578,
	"images/foods/Vegetables/11298_parsnips.jpg": 79864,
	"images/foods/Vegetables/11304_green_peas.jpg": 92015,
	"images/foods/Vegetables/11333_green_peppers.jpg": 11593,
	"images/foods/Vegetables/11352_potatoes_raw.jpg": 59599,
	"images/foods/Vegetables/11357_potatoes_baked.jpg": 58647,
	"images/foods/Vegetables/11365_potatoes_mashed.jpg": 42503,
	"images/foods/Vegetables/11422_pumpkin.jpg": 46315,
	"images/foods/Vegetables/11429_radishes.jpg": 11101,
	"images/foods/Vegetables/11435_rutabagas.jpg": 2459,
	"images/foods/Vegetables/11439_sauerkraut.jpg": 80616,
	"images/foods/Vegetables/11457_spinach_raw.jpg": 68584,
	"images/foods/Vegetables/11458_spinach_cooked.jpg": 99262,
	"images/foods/Vegetables/11477_zucchini.jpg": 71982,
	"images/foods/Vegetables/11482_acorn_squash.jpg": 14392,
	"images/foods/Vegetables/11485_butternut_squash.jpg": 83201,
	"images/foods/Vegetables/11492_spaghetti_squash.jpg": 99179,
	"images/foods/Vegetables/11507_sweet_potato.jpg": 76047,
	"images/foods/Vegetables/11529_tomatoes_raw.jpg": 53948,
	"images/foods/Vegetables/11530_tomatoes_cooked.jpg": 60661,
	"images/foods/Vegetables/11564_turnips.jpg": 78473,
	"images/foods/Vegetables/11588_water_chestnuts.jpg": 17613,
	"images/foods/Vegetables/11591_watercress.jpg": 88151,
	"images/foods/Vegetables/11601_yams.jpg": 36792,
	"images/foods/Vegetables/11603_jicama.jpg": 94141,
	"images/foods/Vegetables/11670_hot_chili_peppers.jpg": 57677,
	"images/foods/Vegetables/11677_shallots.jpg": 42537,
	"images/foods/Vegetables/11722_yellow_beans.jpg": 62166,
	"images/foods/Vegetables/11821_red_peppers.jpg": 86511,
	"images/foods/Vegetables/11935_ketchup_catsup.jpg": 64181,
	"images/foods/Vegetables/11937_dill_pickles.jpg": 15547,
	"images/foods/Vegetables/11940_sweet_pickles.jpg": 6542,
	"images/foods/Vegetables/11945_relish_sweet.jpg": 66937,
	"images/foods/Vegetables/11952_radicchio.jpg": 25355,
	"images/foods/Vegetables/11955_sundried_tomatoes.jpg": 88343,
	"images/foods/Vegetables/11957_fennel.jpg": 45236,
	"images/foods/Vegetables/11958_relish_pickle.jpg": 76721,
	"images/foods/Vegetables/11959_arugula.jpg": 57955,
	"images/foods/Vegetables/11972_lemon_grass.jpg": 60895,
	"images/foods/Vegetables/11974_grape_leaves.jpg": 31271,
	"images/foods/Vegetables/11976_banana_peppers.jpg": 10248,
	"images/foods/Vegetables/11979_jalapeno_peppers.jpg": 12408,
	"images/foods/Vegetables/11981_hungarian_peppers.jpg": 43686,
	"images/foods/Vegetables/43143_pickled_cabbage.jpg": 35044,
	"images/foods/Vegetables/43146_eggplant_pickled.jpg": 93646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11070;